import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CheckIcon from '@material-ui/icons/Check';
import DetailTextButton from '../atoms/DetailTextButton';
import EditTextButton from '../atoms/EditTextButton';
import DeleteTextButton from '../atoms/DeleteTextButton';
import ShowHideTextButton from '../atoms/ShowHideTextButton';
import AddMenuEventTextButton from '../atoms/AddMenuEventTextButton';
// import DeleteMenuEventTextButton from '../atoms/DeleteMenuEventTextButton';
import listMenuChildTypes from '../../constants/MenuChildType';
import ChangeShashokuOptionTextButton from '../atoms/ChangeShashokuOptionTextButton';
import enabledStripeBilling from '../../constants/StripeBilling';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  textDelete: {
    color: '#ccc',
    textAlign: 'center',
    paddingLeft: 12
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      menuId: PropTypes.number,
      menuChildType: PropTypes.number,
      shopName: PropTypes.string,
      menuName: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.number,
      taxType: PropTypes.string,
      image: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    menus,
    classes,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    editOpenAction,
    deleteOpenAction,
    showHideOpenAction,
    changeShashokuOptionAction,
    message,
    setMessage,
    order,
    orderBy,
    roles,
    addMenuEventAction
    // deleteMenuEventOpenAction
  }) => {
    const sortedResult = _.orderBy(menus, orderBy, order);
    const listMenuTypeHideEdit = ['DEFAULT'];
    const listMenuTypeHideEditForShopGroup = ['AKISHIMA', 'EVENT'];
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(gochiMenu => {
            let option = null;
            let titleStatus = null;
            if (gochiMenu.shashokuOption) {
              if (
                gochiMenu.shashokuFlag === 1 &&
                gochiMenu.gochimeshiFlag === 1
              ) {
                option = 'both';
              } else {
                option =
                  gochiMenu.shashokuFlag === 1 ? 'shashoku' : 'gochimeshi';
              }
            }
            const titleStatusArr = [];
            if (gochiMenu.gochimeshiFlag === 1) {
              titleStatusArr.push('ごちめし（さきめし含む）');
            }
            if (gochiMenu.shashokuFlag === 1) {
              titleStatusArr.push('社食ごちめし');
            }
            if (gochiMenu.gochiKidFlag === 1) {
              titleStatusArr.push('こどもごちめし');
            }
            titleStatus = titleStatusArr.join(', ');
            const params = {
              id: gochiMenu.menuId,
              showHide: gochiMenu.showHide,
              gochimeshiFlag: gochiMenu.gochimeshiFlag,
              shashokuFlag: gochiMenu.shashokuFlag,
              gochiKidFlag: gochiMenu.gochiKidFlag,
              menuEventId: gochiMenu.menuEventId,
              subscriptionCheck: !!gochiMenu.subscription,
              menuEvents: gochiMenu.menuEventManuals,
              menuChildType: parseInt(gochiMenu.menuChildType, 10)
            };

            const key = `${gochiMenu.menuId}-${gochiMenu.shopId}-${
              gochiMenu.groupName
            }`;

            return (
              <TableRow key={key} hover>
                <TableCell>
                  {roles.isSecretariat &&
                    !listMenuTypeHideEdit.includes(gochiMenu.menuType) &&
                    gochiMenu.displayType !== 'HIDDEN' && (
                      <EditTextButton
                        id={gochiMenu.menuId}
                        onClickAction={editOpenAction}
                      />
                    )}
                  {!roles.isSecretariat &&
                    !listMenuTypeHideEditForShopGroup.includes(
                      gochiMenu.menuType
                    ) &&
                    !listMenuTypeHideEdit.includes(gochiMenu.menuType) &&
                    gochiMenu.menuCombo !== 1 &&
                    gochiMenu.displayType !== 'HIDDEN' && (
                      <EditTextButton
                        id={gochiMenu.menuId}
                        onClickAction={editOpenAction}
                      />
                    )}
                </TableCell>
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>{gochiMenu.shopId}</TableCell>
                )}
                <TableCell>{gochiMenu.menuId}</TableCell>
                <TableCell>
                  {listMenuChildTypes.map(item => {
                    if (parseInt(gochiMenu.menuChildType, 10) === item.id) {
                      return item.name;
                    }
                    return '';
                  })}
                </TableCell>
                <TableCell>
                  {gochiMenu.menuCombo === 1 && (
                    <CheckIcon className={classes.leftIcon} />
                  )}
                </TableCell>
                <TableCell>
                  {gochiMenu.menuLimitTotal === 1
                    ? '一円単位利用'
                    : '一枚単位利用'}
                </TableCell>
                {enabledStripeBilling === true && (
                  <TableCell>
                    {gochiMenu.subscription === 1 &&
                      `${gochiMenu.subscriptionIntervalCount}${
                        gochiMenu.subscriptionInterval === 'WEEK'
                          ? '週間'
                          : 'ヶ月'
                      }1回`}
                  </TableCell>
                )}
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>{gochiMenu.groupName}</TableCell>
                )}
                <TableCell>{gochiMenu.shopName}</TableCell>
                <TableCell>{gochiMenu.menuName}</TableCell>
                <TableCell>{gochiMenu.price}</TableCell>
                <TableCell>{gochiMenu.taxTypeStr}</TableCell>
                <TableCell>{gochiMenu.quantity}</TableCell>
                <TableCell>
                  <ChangeShashokuOptionTextButton
                    disabled={option === null}
                    titleStatus={titleStatus}
                    params={params}
                    onClickAction={changeShashokuOptionAction}
                  />
                </TableCell>
                <TableCell>
                  {gochiMenu.displayType !== 'HIDDEN' && (
                    <ShowHideTextButton
                      params={params}
                      onClickAction={showHideOpenAction}
                      showHide={gochiMenu.showHide}
                      disabled={
                        gochiMenu.menuEventId &&
                        gochiMenu.showHide === 0 &&
                        (roles.isShop || roles.isGroup)
                      }
                    />
                  )}
                </TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
                <TableCell>
                  {/* {!roles.isShop && !roles.isGroup && (
                    <DeleteTextButton
                      id={gochiMenu.menuId}
                      onClickAction={deleteOpenAction}
                    />
                  )} */}
                  {gochiMenu.displayType !== 'HIDDEN' ? (
                    <DeleteTextButton
                      id={gochiMenu.menuId}
                      onClickAction={deleteOpenAction}
                    />
                  ) : (
                    <div className={classes.textDelete}>削除済</div>
                  )}
                </TableCell>

                <TableCell>
                  <AddMenuEventTextButton
                    titleStatus="イベントメニュー追加"
                    params={params}
                    onClickAction={addMenuEventAction}
                    message={message}
                    setMessage={setMessage}
                    disabled={gochiMenu.subscription === 1}
                  />
                </TableCell>
                <TableCell>
                  {/* <DeleteMenuEventTextButton
                    id={gochiMenu.menuId}
                    onClickAction={deleteMenuEventOpenAction}
                    disabled={!gochiMenu.menuEventId}
                  /> */}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
